import VerifiedIcon from '@hero/ui-kit/icons/utility/VerifiedIcon';
import Container from '@hero/ui-kit/layout/Container';
import Section from '@hero/ui-kit/layout/Section';
import P from '@hero/ui-kit/typography/P';
import React from 'react';

interface VerifiedUserProps {
    adminEmail: string;
    serialNumber: string;
}

const VerifiedUser: React.FC<VerifiedUserProps> = ({ adminEmail, serialNumber }) => {
    return (
        <Section
            styles={{
                // background: 'var(--color-success-epsilon)',
                // border: '2px solid var(--color-success-alpha)',
                background: '#f7f7f7',
                border: '2px solid var(--color-neutrals-borderAlpha)',
                padding: 'var(--gutter)',
                borderRadius: '20px'
            }}
        >
            <Section noDefaultPadding marginBottom="regular">
                <div
                    style={{
                        display: 'flex',
                        columnGap: 'calc(var(--gutter) / 2)'
                    }}
                >
                    <VerifiedIcon size="regular" />
                    <div>
                        <P size="large" strong noDefaultMargin>
                            Verified User!
                        </P>
                        <P noDefaultMargin>Already using Hero dispenser.</P>
                    </div>
                </div>
            </Section>

            <Container gridTemplateColumns={'1fr 1fr'} gridColumnGap="regular">
                <P
                    size="small"
                    noDefaultMargin
                    styles={{
                        textTransform: 'uppercase',
                        fontSize: '1.2rem',
                        marginBottom: '1.2rem',
                        fontWeight: 600,
                        letterSpacing: '0.1rem'
                    }}
                >
                    Hero Admin Email
                </P>
                <P
                    size="small"
                    noDefaultMargin
                    styles={{
                        textTransform: 'uppercase',
                        fontSize: '1.2rem',
                        marginBottom: '1.2rem',
                        fontWeight: 600,
                        letterSpacing: '0.1rem'
                    }}
                >
                    Hero Serial Number
                </P>
                <P noDefaultMargin strong>
                    {adminEmail}
                </P>
                <P noDefaultMargin strong>
                    {serialNumber}
                </P>
            </Container>
        </Section>
    );
};

export default VerifiedUser;
